<template>
  <div class="currencySettings">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <van-search
            v-model="searchText"
            show-action
            shape="round"
            background="transparent"
            :placeholder="$t.currencySettings.searchText"
          >
            <template #action>
              <div @click="onSearch">{{ $t.meta.search }}</div>
            </template>
          </van-search>
        </van-col>
        <van-col class="colItem2">
          <div :class="isFilter() ? 'isFilter' : ''">
            <span @click="showFilter = true">{{ $t.meta.filter }}</span>
          </div>
        </van-col>
      </van-row>
    </div>

    <van-list
      class="list"
      v-model="loading"
      :finished="finished"
      :finished-text="$t.meta.noMore"
      :error.sync="error"
      :error-text="errorText"
      @load="getList(page + 1)"
    >
      <div class="list-container" v-for="(item, index) in tableData" :key="index">
        <div class="list-item">
          {{ $t.currencySettings.currency }}：{{ item.Currency }}
        </div>
        <div class="list-item">
          {{ $t.currencySettings.currencySn }}：{{ item.CurrencySn }}
        </div>
        <div class="list-item">
          {{ $t.currencySettings.currencySymbol }}：{{ item.CurrencySymbol }}
        </div>
        <div class="list-item">
          {{ $t.currencySettings.useState }}：
          <span v-if="item.UseState == '1'">{{ $t.meta.enable }}</span>
          <span v-else>{{ $t.meta.disable }}</span>
        </div>
        <div class="list-item">
          {{ $t.currencySettings.settlement }}：
          <span class="list-icon" v-if="item.IsSettlementCurrency == '1'"
            ><van-icon name="success"
          /></span>
        </div>
        <div class="buttons">
          <van-button
            :class="item.UseState == '1' ? 'default-btn' : 'search-btn'"
            size="small"
            type="primary"
            @click="editSystemCurrencyUseState(item)"
          >
            <span v-if="item.UseState == '1'">{{ $t.meta.disable }}</span>
            <span v-else>{{ $t.meta.enable }}</span></van-button
          >

          <van-button
            class="primary-btn"
            size="small"
            type="primary"
            @click="setSettlementCurrency(item.SCId)"
          >
            {{ $t.currencySettings.setCurrency }}
          </van-button>

          <van-button
            class="primary-btn"
            size="small"
            type="primary"
            @click="gotoDetail(item)"
            >{{ $t.meta.editButton }}</van-button
          >

          <van-button
            class="danger-btn"
            size="small"
            type="primary"
            @click="deleteSystemCurrencySettings(item.SCId)"
          >
            {{ $t.meta.delete }}
          </van-button>
        </div>
      </div>
    </van-list>

    <van-popup
      v-model="showFilter"
      position="bottom"
      :style="{ height: '80%', width: '100%' }"
    >
      <div class="popup-header">{{ $t.meta.allFilter }}</div>
      <van-form>
        <div class="radio-label">
          {{ $t.currencySettings.useState }}
        </div>
        <van-radio-group v-model="useState" direction="horizontal">
          <van-radio name="1">{{ $t.meta.effective }}</van-radio>
          <van-radio name="0">{{ $t.meta.disable }}</van-radio>
        </van-radio-group>
      </van-form>
      <div class="popup-footer">
        <van-button class="reset" type="info" block square @click="filterReset">{{
          $t.meta.reset
        }}</van-button>

        <van-button class="confirm" type="primary" block square @click="filterSubmit">{{
          $t.meta.confirm
        }}</van-button>
      </div>
    </van-popup>

    <div class="tool-bar">
      <van-button type="info" block @click="gotoDetail(null)">{{
        $t.currencySettings.addButton
      }}</van-button>
    </div>
  </div>
</template>

<script>
import {
  List,
  Row,
  Col,
  Search,
  Button,
  Form,
  Field,
  Popup,
  Radio,
  RadioGroup,
  Icon,
} from "vant";

import Vue from "vue";
Vue.use(List)
  .use(Row)
  .use(Col)
  .use(Search)
  .use(Button)
  .use(Form)
  .use(Field)
  .use(Popup)
  .use(Radio)
  .use(RadioGroup)
  .use(Icon);

export default {
  name: "currencySettings",
  data() {
    return {
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      tableData: [],
      page: 0,
      pageSize: 10,
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //filter
      searchText: "",
      useState: null,
      showFilter: false,
    };
  },
  created() {},
  methods: {
    gotoDetail(item) {
      var data = item;
      localStorage.setItem("currencySettingsDetail", JSON.stringify(data));
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "currencySettingsDetail",
        name: "currencySettingsDetail",
        query: [
          {
            name: "IsEdit",
            value: data ? true : false,
          },
        ],
      });
    },
    onSearch() {
      this.initList();
      this.getList(1);
    },
    isFilter() {
      if (this.useState) {
        return true;
      } else {
        return false;
      }
    },
    filterReset() {
      this.searchText = "";
      this.useState = null;
      this.initList();
      this.getList(1);
    },
    filterSubmit() {
      this.initList();
      this.getList(1);
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.showFilter = false;
      this.tableData = [];
    },
    editSystemCurrencyUseState(item) {
      this.$commonMethod.showLoading();
      var param = {
        SCId: item.SCId,
        UseState: item.UseState == "1" ? 0 : 1,
      };
      this.$api.systemManagement
        .editSystemCurrencyUseState(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.initList();
          this.getList(1);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    setSettlementCurrency(id) {
      this.$commonMethod.showLoading();
      var param = {
        SCId: id,
      };
      this.$api.systemManagement
        .setSettlementCurrency(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.initList();
          this.getList(1);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    deleteSystemCurrencySettings(id) {
      this.$commonMethod.showLoading();
      var param = {
        SCId: id,
      };
      this.$api.systemManagement
        .deleteSystemCurrencySettings(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.initList();
          this.getList(1);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    getList(page) {
      var param = {
        PageIndex: page,
        PageSize: this.pageSize,
        UseState: this.useState,
        Currency: this.searchText,
      };
      this.$api.systemManagement
        .getSystemCurrencySettingsList(param)
        .then((res) => {
          this.tableData = this.tableData.concat(res.data.Data);
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.page = res.meta.page;
          this.finished = this.page >= res.meta.lastPage;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.currencySettings {
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    border-bottom: 1px solid #ebedf0;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItem1 {
        width: 80%;
        text-align: center;
        font-size: 14px;
        .van-search__content {
          padding: 0px;
          margin-right: 10px;
          .van-cell {
            padding: 5px 8px 5px 8px;
          }
        }
        .custom-date {
          padding: 10px;
          .date-btn1 {
            width: 40%;
            display: inline-block;
            border-right: 1px solid #ebedf0;
            line-height: 33px;
            vertical-align: middle;
          }
          .date-btn2 {
            width: 40%;
            display: inline-block;
            line-height: 33px;
            vertical-align: middle;
          }
          .van-button {
            vertical-align: middle;
          }
        }
      }
      .colItem2 {
        width: 20%;
        text-align: center;
        font-size: 14px;
        .isFilter {
          color: $-color-primary;
          font-weight: bold;
        }
      }
    }
  }
  .list {
    .list-container {
      font-size: 12px;
      color: #333;
      padding: 10px;
      margin-top: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
      .list-item {
        margin-bottom: 10px;
        .list-icon {
          font-size: 20px;
          display: inline-block;
          width: 50px;
          text-align: center;
          .van-icon {
            color: #13ce66;
            margin: auto;
          }
        }
      }
      .buttons {
        text-align: right;
        .primary-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-primary;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .default-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-light-gray;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .search-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-green;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .danger-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-red;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
      }
    }
  }
  .popup-header {
    margin-top: 20px;
    margin-bottom: 10px;
    padding-bottom: 10px;
    text-align: center;
    font-size: 16px;
  }
  .radio-label {
    color: #646566;
    margin-bottom: 10px;
    font-size: 14px;
  }
  .van-radio-group {
    margin-bottom: 20px;
  }
  .van-radio {
    margin-bottom: 10px;
    font-size: 14px;
    ::v-deep .van-radio__label {
      color: #646566;
    }
  }
  .van-form {
    width: 90%;
    margin: auto;
    padding-bottom: 20vw;
    .van-cell:after {
      border: none;
    }
    .van-cell {
      border-bottom: 1px solid #ebedf0;
    }
  }
  .popup-footer {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 100;
    background-color: white;
    padding-bottom: env(safe-area-inset-bottom);
    width: 100%;
    .reset {
      width: 50%;
      display: inline-block;
      color: $-color-primary;
      background: #ffffff;
      border: none;
    }
    .confirm {
      width: 50%;
      display: inline-block;
      color: #ffffff;
      background: $-color-primary;
      border: none;
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
